import { render, staticRenderFns } from "./ConfirmPropose.vue?vue&type=template&id=44d059c3&scoped=true"
import script from "./ConfirmPropose.vue?vue&type=script&lang=js"
export * from "./ConfirmPropose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d059c3",
  null
  
)

export default component.exports